export { default } from './MarketingPageLayout.js';
